import {getCookie} from '../utils/cookies'

const CONSENT_COOKIE = 'cookieyes-consent'
const CONSENT_EVENT = 'cookieyes_consent_update'

function categoryAccepted(category: string): boolean {
    const consent = getCookie(CONSENT_COOKIE)
    if (!consent) return false
    return consent.includes(`${category}:yes`)
}

export default class Embeds {
    constructor() {
        const embeds = document.querySelectorAll<HTMLElement>('[data-embed]')
        for (const embed of embeds) {
            new Embed(embed)
        }
    }
}

class Embed {
    private el: HTMLElement
    private category: string

    constructor(el: HTMLElement) {
        this.el = el
        this.category = el.dataset.embedCategory || 'advertisement'

        if (categoryAccepted(this.category)) {
            this.reveal()
        } else {
            document.addEventListener(CONSENT_EVENT, this.onConsentUpdate)
        }
    }

    private onConsentUpdate = () => {
        if (!categoryAccepted(this.category)) return
        document.removeEventListener(CONSENT_EVENT, this.onConsentUpdate)
        this.reveal()
    }

    private reveal() {
        const template = this.el.querySelector<HTMLTemplateElement>('[data-embed-code]')
        if (!template) return

        const content = document.createElement('div')
        content.className = 'ce-embed__content'
        content.appendChild(template.content.cloneNode(true))

        this.el.querySelector('[data-embed-notice]')?.remove()
        template.remove()
        this.el.appendChild(content)

        // Cloned <script> nodes do not execute; re-create them so widgets load.
        runScripts(content)
    }
}

function runScripts(container: HTMLElement) {
    for (const original of Array.from(container.querySelectorAll('script'))) {
        const script = document.createElement('script')
        for (const attribute of Array.from(original.attributes)) {
            script.setAttribute(attribute.name, attribute.value)
        }
        script.text = original.textContent ?? ''
        original.replaceWith(script)
    }
}
